// Store the observer so that we can disconnect it later
let observer;

/**
 * Load the image by setting the src. Once the image is loaded, add loaded class
 * and remove event listener
 * @param {object} el
 */
function loadImage(el) {
  const imageElement = el;

  function imageLoaded(){
    el.classList.add("loaded");
    imageElement.removeEventListener("load", imageLoaded);
  }

  if (imageElement && imageElement.src != imageElement.dataset.url) {
    imageElement.addEventListener("load", imageLoaded);
    imageElement.src = imageElement.dataset.url;
  }
}

/**
 * Initialize the lazy load directive. If IntersectionObserver is not supported,
 * default to loading images right away
 * @param {object} el
 */
function init(el) {

  function handleIntersect(entries, observer) {
    entries.forEach(entry => {
      // In Edge 15, isIntersecting returns undefined even though it supports IntersectionObserver ¯\_(ツ)_/¯
      if (entry.isIntersecting === undefined) {
        loadImage(el);
        observer.unobserve(el);
      } else if (!entry.isIntersecting) {
        return;
      } else {
        loadImage(el);
        observer.unobserve(el);
      }
    });
  }

  function createObserver() {
    const options = {
      // circumstances under which the observer's callback is invoked
      root: null, // defaults to the browser viewport if not specified or if null
      threshold: "0" // 0-1, 1.0 means that when 100% of the target is visible within and 0 means when 1px of the target is visible
    };

    observer = new IntersectionObserver(handleIntersect, options);

    observer.observe(el); // target element to watch
  }

  el.classList.add("lazy-load");

  if (!window["IntersectionObserver"]) {
    loadImage(el);
  } else {
    createObserver(el);
  }
}

/**
 * Disconnect the IntersectionObserver, reset the src attribute, and reset classes
 * @param {object} el
 */
function destroy(el){
  if (window["IntersectionObserver"]) {
    observer.disconnect;
  }
  el.src = '';
  el.classList.remove("loaded");
}


// Directive Exports
export default {
  unbind: el => {
    if (el.src != el.dataset.url) {
      destroy(el);
    }
  },
  update: el => {
    if (el.src != el.dataset.url) {
      destroy(el);
      init(el);
    }
  },
  inserted: el => {
    init(el);
  }
};



// WEBPACK FOOTER //
// ./src/directives/LazyLoadDirective.js